import { render } from "./Navbar.vue?vue&type=template&id=45bc7814&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=45bc7814&scoped=true&lang=css"
import "./Navbar.vue?vue&type=style&index=1&id=45bc7814&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bc7814"]])

export default __exports__